export default __webpack_public_path__ + "static/om-716feea54634c16f406a0bdd4efa9b21.svg";